import React from 'react'

const Accordion = ({ content, collapseOpen = false }) => {
    return (
        <div className="join join-vertical rounded-lg shadow-xl w-full z-0">
            {content.map((row) => (
                <div className={`collapse ${collapseOpen && 'collapse-open'} collapse-arrow join-item border border-base-300`} key={row.title}>
                    <input type="radio" name="faqs-accordion" />
                    <div className="text-xl collapse-title text-base-100 font-bold bg-secondary">
                        {row.title}
                    </div>
                    <div className="collapse-content bg-base-100">
                        {row.content}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Accordion